import { render, staticRenderFns } from "./No18.vue?vue&type=template&id=61cf8e82&scoped=true"
import script from "./No18.vue?vue&type=script&lang=js"
export * from "./No18.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf8e82",
  null
  
)

export default component.exports